import React, {useCallback, useContext, useEffect, useReducer, useState} from 'react';
import {BaseStyle} from "../../../styles/shared/BaseStyle";
import {
	AccordionActions,
	Button,
	Container,
	DialogActions,
	DialogContentText,
	Divider,
	Paper,
} from "@mui/material";
import {FormProvider, useForm} from "react-hook-form";
import Grid from "@mui/material/Grid";
import {categoriesV2} from "../../../utils/dictionaries/Categories";
import Typography from "@mui/material/Typography";
import {ContentState, convertFromHTML, convertFromRaw, convertToRaw} from 'draft-js'
import {stateToHTML} from "draft-js-export-html";
import {FAQ_INITIAL_STATE, FaqReducer, initFaqState} from "../../../reducers/FaqReducer";
import {deleteFaq, generateFaq, searchFaq, updateFaq} from "../../../services/FaqServices";
import {AppContext} from "../../../App";
import {setOpenSnackbar} from "../../../services/AppServices";
import AccordionFaq from "./AccordionFaq";
import SimpleDialog from "../../widgets/dialogs/SimpleDialog";
import FaqForm from "./FaqForm";
import {getKeyByValue} from "../../../utils/GenericUtils";
import clsx from "clsx";
import Background from "../../../assets/Ocean-bg.png";
import HideAppBar from "../../widgets/header/HideAppBar";


const GestioneFaq = () => {
	const classes = BaseStyle();
	const appContext = useContext(AppContext);
	const [state, dispatch] = useReducer(FaqReducer, FAQ_INITIAL_STATE, initFaqState);
	const [tags, setTags] = useState([]);
	const [deleteConfirm, setDeleteConfirm] = useState(false);
	const [modifyFaq, setModifyFaq] = useState(false);
	const [faqSelected, setFaqSelected] = useState();
	const [reset, setReset] = useState(false);
	const [risposta, setRisposta] = useState("");

	const methods = useForm({
		mode: "onChange"
	})

	const handleKeyDown = event => {
		switch (event.key) {
			case ",":
			case " ": {
				event.preventDefault();
				event.stopPropagation();
				if (event.target.value.length > 0) {
					setTags([...tags, event.target.value]);
				}
				break;
			}
			default:
		}
	};

	const stringToHtml = useCallback((string) => {
		let risposta = JSON.parse(string);
		let raw = convertFromRaw(risposta);
		return stateToHTML(raw);
	}, [])

	const htmlToString = useCallback((html) => {
		const blocksFromHTML = convertFromHTML(html);
		const state = ContentState.createFromBlockArray(
			blocksFromHTML.contentBlocks,
			blocksFromHTML.entityMap,
		);
		return JSON.stringify(convertToRaw(state))
	}, [])

	const onSubmit = useCallback((data) => {
		if (tags.length === 0) {
			setOpenSnackbar("warning", "Inserisci almeno un tag!", appContext.dispatch)
			return;
		}
		let html = stringToHtml(data.risposta);
		if (html.toString().length <= 11) {
			setOpenSnackbar("warning", "La risposta non è sufficientemente esaustiva!", appContext.dispatch)
			return;
		}
		let faq = {
			...data,
			categoria: categoriesV2[data.categoria].label,
			risposta: html,
			keywords: tags.join(),
		}
		generateFaq(faq, dispatch);
	}, [tags, dispatch, appContext.dispatch, stringToHtml]);

	const onModifySubmit = useCallback((data) => {
		if (tags.length === 0) {
			setOpenSnackbar("warning", "Inserisci almeno un tag!", appContext.dispatch)
			return;
		}
		let html = stringToHtml(data.risposta);
		if (html.toString().length <= 11) {
			setOpenSnackbar("warning", "La risposta non è sufficientemente esaustiva!", appContext.dispatch)
			return;
		}
		let faq = {
			...faqSelected,
			...data,
			categoria: categoriesV2[data.categoria].label,
			risposta: html,
			keywords: tags.join(),
		}
		updateFaq(faq, dispatch);
	}, [faqSelected, tags, dispatch, appContext.dispatch, stringToHtml])

	const openModifyDialog = useCallback((faq) => {
		if (!reset) {
			setFaqSelected(faq);
			let categoriaKey = parseInt(getKeyByValue(categoriesV2, faq.categoria));
			methods.reset({
				domanda: faq.domanda,
				categoria: categoriaKey,
			});
			setRisposta(htmlToString(faq.risposta));
			setTags(faq?.keywords?.split(","));
			setModifyFaq(true);
			setReset(true);
		}
	}, [methods, reset, htmlToString])

	const confirmDeleteFaq = useCallback(() => {
		deleteFaq(faqSelected, dispatch);
	}, [dispatch, faqSelected])

	const closeModifyDialog = useCallback(() => {
		methods.reset({});
		setTags([]);
		searchFaq({}, dispatch);//TODO io posso avere più ruoli, serve lato backend il filtro, sennò lo faccio poi con la giusta calma
		setModifyFaq(false);
	}, [methods])

	useEffect(() => {
		methods.register("risposta")
	}, [methods]);

	useEffect(() => {
		searchFaq({}, dispatch);
	}, [dispatch])

	useEffect(() => {
		if (!state.loadingAddFaq && state.errorAddFaq === "") {
			setOpenSnackbar("success", "Faq registrata con successo", appContext.dispatch);
			methods.reset();
			setTags([]);
			setFaqSelected({});
			searchFaq({}, dispatch);
		} else if (!state.loadingAddFaq && state.errorAddFaq.length > 1) {
			setOpenSnackbar("error", state.errorAddFaq, appContext.dispatch);
		}
	}, [state.loadingAddFaq, state.errorAddFaq, appContext.dispatch, methods, setTags])

	useEffect(() => {
		if (!state.loadingDeleteFaq && state.errorDeleteFaq === "") {
			console.log("#delete faq success")
			setOpenSnackbar("success", "Faq eliminata con successo", appContext.dispatch);
			setDeleteConfirm(false);
			searchFaq({}, dispatch);
		} else if (!state.loadingDeleteFaq && state.errorDeleteFaq.length > 1) {
			console.log("#delete faq success")
			setOpenSnackbar("error", state.errorDeleteFaq, appContext.dispatch);
		}
	}, [state.loadingDeleteFaq, state.errorDeleteFaq, appContext.dispatch, dispatch])

	useEffect(() => {
		if (!state.loadingUpdateFaq && state.errorUpdateFaq === "" && reset) {
			console.log("#update faq success")
			setOpenSnackbar("success", "Faq aggiornata con successo", appContext.dispatch);
			setTags([]);
			setFaqSelected({});
			setModifyFaq(false);
			searchFaq({}, dispatch);
			methods.reset({
				domanda: "",
				categoria: "",
			})
			setReset(false);
		} else if (!state.loadingUpdateFaq && state.errorUpdateFaq.length > 1) {
			console.log("#update faq error")
			setOpenSnackbar("error", state.errorUpdateFaq, appContext.dispatch);
		}
	}, [state.loadingUpdateFaq, state.errorUpdateFaq, appContext.dispatch, dispatch, setTags, methods, reset])

	useEffect(() => {
		document.body.style =
			`background-image: url(${Background});
		background-attachment: fixed;
    background-size: cover;`;
	}, []);

	return (
		<React.Fragment>
			<main className={classes.main}>
				<HideAppBar title={"Gestione FAQ"}/>
				<Container maxWidth={"xl"} component={"article"} style={{paddingTop: 12}}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<Paper className={clsx(classes.roundPaper)}>
								{
									state.loadingSearchFaq ? "...sto caricando ..." :
										state.errorSearchFaq !== "" ? "...Errore..." :
											<FormProvider {...methods} >
												<FaqForm tags={tags} setTags={setTags} onSubmit={onSubmit} handleKeyDown={handleKeyDown}
												         showPreview={true}/>
											</FormProvider>
								}
							</Paper>
						</Grid>
						<Grid item xs={12} className={classes.faqDetails} style={{marginBottom: 20}}>
							<Paper className={clsx(classes.roundPaper)} style={{padding: 8}}>
								<Typography variant={"subtitle1"} style={{padding: 8}}>
									Visualizza, modifica o elimina una FAQ cliccando su di essa.
								</Typography>
								{
									state.loadingSearchFaq ? "...sto caricando le faq..." :
										state.errorSearchFaq !== "" ? "Ops, errore" :
											state.faqs.map((faq, index) => {
												return (
													<AccordionFaq key={index} domanda={faq.domanda} risposta={faq.risposta} actions={
														<AccordionActions>
															<Divider/>
															<Button size="small" className={classes.roundButton}
															        onClick={() => {
																        setFaqSelected(faq);
																        setDeleteConfirm(true);
															        }}><b>Elimina</b></Button>
															<Button size="small" disableElevation variant={"contained"} color={"primary"}
															        className={classes.roundButton}
															        onClick={() => openModifyDialog(faq)}>
																<b>Modifica</b>
															</Button>
														</AccordionActions>
													}/>
												)
											})
								}
							</Paper>
						</Grid>
					</Grid>
				</Container>
			</main>
			{
				deleteConfirm &&
				<SimpleDialog open={deleteConfirm} handleClose={() => setDeleteConfirm(false)}
				              title={"Confermi di voler eliminare la FAQ?"}
				              content={<DialogContentText>Confermando la cancellazione della FAQ questa non sarà più disponibile
					              e dovrai ricrearla da zero in caso tu voglia recuperarla.</DialogContentText>}
				              actions={
					              <DialogActions>
						              <Button onClick={() => setDeleteConfirm(false)} size={"small"}
						                      className={classes.roundButton}>
							              Annulla
						              </Button>
						              <Button onClick={confirmDeleteFaq} size="small" disableElevation variant={"contained"}
						                      className={classes.roundButton} color={"primary"} autoFocus>
							              Conferma
						              </Button>
					              </DialogActions>
				              }/>
			}
			{
				modifyFaq && <SimpleDialog maxWidth={"xl"} open={modifyFaq} handleClose={closeModifyDialog}
				                           title={"Modifica della FAQ n° " + faqSelected?.id}
				                           content={
					                           <FormProvider {...methods} >
						                           <FaqForm tags={tags} setTags={setTags} onSubmit={onModifySubmit}
						                                    handleKeyDown={handleKeyDown}
						                                    risposta={risposta} isDefault={true}/>
					                           </FormProvider>
				                           }
				                           actions={
					                           <DialogActions>
						                           <Button onClick={closeModifyDialog} size={"small"}
						                                   className={classes.roundButton}>
							                           <b>annulla</b>
						                           </Button>
						                           <Button onClick={methods.handleSubmit(onModifySubmit)} size="small"
						                                   disableElevation
						                                   variant={"contained"}
						                                   className={classes.roundButton} color={"primary"} autoFocus>
							                           <b>conferma modifiche</b>
						                           </Button>
					                           </DialogActions>
				                           }/>
			}
		</React.Fragment>
	);
};

export default React.memo(GestioneFaq);
